/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Theme_Dark_ModeInputs */

const nl_common_theme_dark_mode = /** @type {(inputs: Common_Theme_Dark_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donkere modus`)
};

/**

* @param {Common_Theme_Dark_ModeInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_theme_dark_mode = /** @type {((inputs?: Common_Theme_Dark_ModeInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Theme_Dark_ModeInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_theme_dark_mode(inputs)
});
export { common_theme_dark_mode as "common.theme.dark_mode" }